<app-mobile-header-secondary title="{{ 'profile.title' | translate }}"></app-mobile-header-secondary>

<article class="configuration-item" *ngIf="currentUser">
  <div class="row mb-4">
    <div class="col-8">
      <div class="configuration-title mb-1">{{ 'profile.security' | translate }}</div>
      <div class="configuration-text">{{ 'settings.securityInfoData' | translate }}</div>
      <!-- <a href="javascript:void(0)" class="configuration-link"><i class="fal fa-question-circle"></i> Ajuda sobre essa tela</a> -->
    </div>
  </div>

  <div class="configuration-subtitle font-weight-bold">{{ 'profile.accessData' | translate }}</div>
  <div class="row">
    <div class="col-lg-6">
      <label class="field__holder">
        <input type="text" class="field" [value]="currentUser.email" disabled />
        <span class="field__placeholder">{{ 'profile.email' | translate }}</span>
        <button class="input-btn btn-S btn-text" (click)="!currentUser.email || !currentUser.email_verified_at ? openSetMissingUserInfoModal() : openEditEmailModal()">
          {{ 'settings.edit' | translate }}
        </button>
      </label>
    </div>
  </div>
  <div class="row" *ngIf="!currentUser?.organization?.type">
    <div class="col-lg-6">
      <label class="field__holder">
        <input type="password" class="field" value="This is not your password" disabled />
        <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
        <button class="input-btn btn-S btn-text" (click)="openEditPasswordModal()">
          {{ 'settings.edit' | translate }}
        </button>
      </label>
    </div>
  </div>
</article>

<article class="configuration-item" *ngIf="!currentUser?.organization?.type">
  <div class="row mb-4">
    <div class="col-8">
      <div class="configuration-title mb-1">{{ 'profile.2fa' | translate }}</div>
      <div class="configuration-text">{{ 'settings.2faInfoData' | translate }}</div>
    </div>
    <div class="col-4 d-flex justify-content-end">
      <button type="button" class="autentique-button" [disabled]="isLoading" (click)="openAddMfaModal()"><i class="fa-regular fa-plus mr-2"></i> {{ 'button.add' | translate }}</button>
    </div>
  </div>

  <div class="configuration-subtitle font-weight-bold">{{ 'profile.2faScopes' | translate }}</div>
  <div class="totp-list">
    <div class="totp-list__item" *ngIf="!currentUser || currentUser.mfa.length === 0">{{ 'settings.noMfa' | translate }}</div>
    <div class="totp-list__item" *ngFor="let item of currentUser?.mfa || []">
      {{ 'auth.mfa.' + item | translate }}

      <div class="totp-list__item-ellipsis" ngbDropdown placement="bottom-right">
        <button type="button" class="totp-list__item-ellipsis-dropdown" ngbDropdownToggle>
          <i class="fa-regular fa-ellipsis-vertical"></i>
        </button>
        <div ngbDropdownMenu>
          <button class="text-danger" ngbDropdownItem [disabled]="isLoading" (click)="deleteMfaItem()"><i class="fa-regular fa-trash icon text-danger"></i> {{ 'settings.remove' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</article>
